/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://uesk323jjjaqnkcown5wp6qnb4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-w2ircur64jdhfbxvretw35ihqq",
    "aws_cognito_identity_pool_id": "us-east-2:d9f5141e-81cb-4852-921f-21045aefb3ea",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_xUQIYNc2p",
    "aws_user_pools_web_client_id": "q1it8d9ind59j96m36uc7ta8l",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplify-react-graphql-image203808-staging",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
